export default __webpack_public_path__ + "assets/grid-green-c4bd6f045c9461ab4b7099236ab41e47.svg";